export const BLOCK_EXPLORER = {
    USDT: 'https://etherscan.io/tx/',
    ETH: 'https://etherscan.io/tx/',
    BLOCKWAVE:'https://etherscan.io/tx/',
}